'use strict';
import { createAction } from 'redux-actions';

const START_AMT_KVM = 'START_AMT_KVM';
const STOP_AMT_KVM = 'STOP_AMT_KVM';

export const startAmtKvm = createAction(START_AMT_KVM);
export const stopAmtKvm = createAction(STOP_AMT_KVM);
